<template>
  <div class="leftthree">
    <div class="ltpos" style="height: 63.12%">
      <div id="category" ref="ecate" style="width:100%;height:100%;z-index: 3;padding: 0.5rem;box-sizing: border-box;"></div>
      <img style="z-index: 2;position: absolute;left: 0;top: 0;" src="../assets/lt.png" alt="">
      <div class="copyimg"><img src="../assets/copylt.png" alt=""></div>
    </div>
    <div class="ltpos" style="margin-bottom: 0">
      <div class="lbintro" style="height: 100%;">
        <swiper :options="swiperOption" ref="mySwiper" style="height: 100%;">
          <swiper-slide style="position: relative;height: 100%;" v-for="(item, index) in tlist" :key="index">
            <div class="simg" style="position: absolute;left: 0;top: 0;z-index: 3;">
              <img :src="item.thumb" alt="">
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <img style="z-index: 2;position: absolute;left: 0;top: 0;" src="../assets/lt.png" alt="">
      <div class="copyimg"><img src="../assets/copylt.png" alt=""></div>
    </div>
  </div>
</template>
<script>
import Bus from '../bus.js'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'LeftThree',
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      tlist: [
      {
        thumb: 'static/expert1.jpg'
      },{
        thumb: 'static/expert2.jpg'
      },{
        thumb: 'static/expert3.jpg'
      },{
        thumb: 'static/expert4.jpg'
      },{
        thumb: 'static/expert5.jpg'
      },{
        thumb: 'static/expert6.jpg'
      },{
        thumb: 'static/expert7.jpg'
      },{
        thumb: 'static/expert8.jpg'
      },{
        thumb: 'static/expert9.jpg'
      },{
        thumb: 'static/expert10.jpg'
      },{
        thumb: 'static/expert11.jpg'
      },{
        thumb: 'static/expert12.jpg'
      },{
        thumb: 'static/expert13.jpg'
      },{
        thumb: 'static/expert14.jpg'
      },{
        thumb: 'static/expert15.jpg'
      },{
        thumb: 'static/expert16.jpg'
      },{
        thumb: 'static/expert17.jpg'
      },{
        thumb: 'static/expert18.jpg'
      },{
        thumb: 'static/expert19.jpg'
      },{
        thumb: 'static/expert20.jpg'
      },{
        thumb: 'static/expert21.jpg'
      },{
        thumb: 'static/expert22.jpg'
      },{
        thumb: 'static/expert23.jpg'
      },{
        thumb: 'static/expert24.jpg'
      },{
        thumb: 'static/expert25.jpg'
      },{
        thumb: 'static/expert26.jpg'
      },{
        thumb: 'static/expert27.jpg'
      },{
        thumb: 'static/expert28.jpg'
      },{
        thumb: 'static/expert29.jpg'
      },{
        thumb: 'static/expert30.jpg'
      }
      ],
      allsum: '',
      swiperOption: {
        notNextTick: true,
        autoplay: 3000,
        // slidesPerView: 1.15,
        spaceBetween: 20,
        loop: true,
        speed: 1000,
        // direction: 'vertical'
      }
    }
  },
  mounted() {
    this.selfcate()
    this.getCategory()
  },
  methods: {
    selfcate() {
      const self = this
      setTimeout(() => {
        window.onresize = function() {
          self.$refs.ecate.resize()
        }
      }, 10)
    },
    getCategory() {
      Bus.$on('changetype', data=>{
        console.log(data)
      })
      var Category = this.$echarts.init(document.getElementById('category'));
      this.$http({
        method: 'post',
        url: 'http://demo.oillink.com/appapi/app_data.php',
        data: this.$qs.stringify({
          action: 'oneway'
        })
      }).then((response) => {
        // console.log(response)
        if (response.data) {
          var option = {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            legend: {
              data: ['公司统计'],
              top: '3%',
              textStyle: {
                color: '#fff'
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              show: false,
            },
            yAxis: {
              type: 'category',
              axisLabel: {
                textStyle: {
                  color: '#ffffff',
                  fontSize: '14',
                }
              },
              data: ['海洋油气工程', '油田地面工程', '增产', '修井', '采油', '射孔', '测井', '完井', '固井', '录井', '钻井', '地球物理勘探']
            },
            series: [{
                name: '公司统计',
                type: 'bar',
                itemStyle: {
                  color: '#00ADFF'
                },
                data: [1299, 252, 1098, 1325, 1912, 687, 3733, 635, 2026, 1982, 4243, 3660],
                label: {
                  normal: {
                    show: true,
                    position: 'right',
                    textStyle: {
                      color: '#ffffff',
                      fontSize: '12',
                    }
                  }
                },
              }

            ]
          };

          Category.setOption(option);
        }
      })
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ltpos {
  position: relative;
  height: 31.56%;
  margin-bottom: 2.66%;
}

.ltpos:hover {
  cursor: pointer;
}

.ltpos img {
  height: 100%;
  width: 100%;
}
.simg{
}
.simg img{
 height: 100%;
}
.copyimg {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
}

.ltposimg {
  position: absolute;
  left: 0;
  top: 0;
}

/*----------------------*/
.lbpos {
  position: relative;
  height: 65.8%;
}

.lbpos img {
  height: 100%;
  width: 100%;
}

.cbintro {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  padding: 1.5rem 1rem;
  box-sizing: border-box;
  height: 90%;
  z-index: 3;
  position: relative;
}

.cbintro .dnum {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 0.6rem;
  color: #00aaff;
  position: absolute;
  top: 5%;
  left: 5%
}

.cbintro .obox {
  width: 100%;
  height: 100%;
  /*overflow: hidden;*/
}

.cbintro .sul {
  padding: 0;
  margin: 1.2rem 0 0;
  width: 100%;
  height: 100%;
  /*display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;*/
}

.cbintro .sul .sli {
  list-style: none;
  width: 100%;
  /*height: 1%;*/
  font-size: 0.6rem;
  padding: 0 0.5rem;
  box-sizing: border-box;
  color: #0090d9;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cbintro .sul .sli:nth-child(odd) {
  background: rgba(0, 144, 217, 0.1);
  color: #ccf7ff;
}
.lbintro {
  padding: 1rem;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/LeftThree.vue